import { type InfiniteData, type QueryClient } from '@tanstack/react-query';

import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type IGetInfiniteSearchResultDesktopResponse } from '@/repositories/generated/shared/search-offers/v2/get-infinite-search-result-desktop';
import { type ISearchOffersDesktopResponse } from '@/repositories/generated/shared/search-offers/v3/search-offers-desktop';

import { getQueryKey } from './internal/config';

export class FetchGetInfiniteSearchResultDesktopLoadService {
  private readonly queryClient: QueryClient;

  public constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;
  }

  public setQueryData(updater: InfiniteData<IGetInfiniteSearchResultDesktopResponse>): void {
    this.queryClient.setQueryData(getQueryKey(), updater);
  }

  public setQueryDataFromOffersListing(offersData: ISearchOffersDesktopResponse): void {
    const { similarOffers } = offersData;

    if (similarOffers) {
      this.setQueryData({ pageParams: [similarOffers.nextPage], pages: [similarOffers] });
    } else {
      this.removeQuery();
    }
  }

  public getQueryData(): InfiniteData<IGetInfiniteSearchResultDesktopResponse> | null {
    return extractUndefined(
      this.queryClient.getQueryData<InfiniteData<IGetInfiniteSearchResultDesktopResponse>>(getQueryKey()),
    );
  }

  public removeQuery(): void {
    this.queryClient.removeQueries({ queryKey: getQueryKey() });
  }
}
